import store from '../store';
import { socketService } from '../api/socketService';
import AudioPlayer, { AUDIO } from '../utils/AudioPlayer';

const sounds = {
  AUDIO,
  player: new AudioPlayer(),
  setup() {
    this.player.setup();
    // this listens for sounds emitted by the quizmaster's client (pub/sub)
    this.listenForSounds();
  },
  pause(sound) {
    this.player.pause(sound);
  },
  play(sound, settings) {
    this.player.play(sound, settings);
  },
  isPlaying(sound) {
    this.player.isPlaying(sound);
  },
  listenForSounds() {
    const self = this;
    socketService.listen('sounds', sound => self.play(sound));
  },
  emitSound(sound) {
    socketService.broadcast('sounds', sound);
  }
};

export default sounds;
